import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

const getTherapistEnrollmentsQueryKey = () => ["getTherapistEnrollments"] as const;

export const useGetTherapistEnrollments = () => {
  const client = useApiClient();

  return useQuery(getTherapistEnrollmentsQueryKey(), () => client.getTherapistEnrollments());
};
